import { useEffect, useState } from 'react';

export function useGetEmailRecords(campaignId) {
  const [records, setRecords] = useState([]);
  useEffect(() => {
    const doFetch = async () => {
      const d = await fetch(`/api/v1/campaign/${campaignId}/records`);
      const data = await d.json();
      await Promise.all(data['email_records'].map(async (vm,i) => {
        data['email_records'][i]['key'] = vm['_id'];
      }));
      setRecords(data['email_records']);
    };
    doFetch();
    // eslint-disable-next-line
  }, []);
  return records;
}
